const roundCurrency = (value) => Math.round((Number(value) || 0) * 100) / 100;

/** Split a booking-level discount across lines; last line absorbs rounding remainder. */
export function allocateLineDiscounts(lineAmounts = [], totalDiscount = 0) {
  const amounts = (lineAmounts || []).map((amount) => Math.max(0, Number(amount) || 0));
  const baseTotal = amounts.reduce((sum, amount) => sum + amount, 0);
  const discount = roundCurrency(Math.min(Math.max(0, Number(totalDiscount) || 0), baseTotal));

  if (discount <= 0 || baseTotal <= 0 || amounts.length === 0) {
    return amounts.map(() => 0);
  }

  let allocated = 0;
  return amounts.map((amount, index) => {
    if (amount <= 0) {
      return 0;
    }
    if (index === amounts.length - 1) {
      return roundCurrency(discount - allocated);
    }
    const share = roundCurrency(discount * (amount / baseTotal));
    allocated = roundCurrency(allocated + share);
    return share;
  });
}

export function resolveReviewDiscount({
  allowDiscount = false,
  discountMode = 'percentage',
  discountPercentage = 0,
  discountAmount = 0,
  totalBasePrice = 0,
}) {
  const base = Math.max(0, Number(totalBasePrice) || 0);
  if (!allowDiscount || base <= 0) {
    return {
      totalDiscount: 0,
      effectivePercentage: 0,
      displayPercentage: 0,
      displayAmount: 0,
    };
  }

  if (discountMode === 'amount') {
    const totalDiscount = roundCurrency(Math.min(Math.max(0, discountAmount), base));
    const effectivePercentage = roundCurrency((totalDiscount * 100) / base);
    return {
      totalDiscount,
      effectivePercentage,
      displayPercentage: effectivePercentage,
      displayAmount: totalDiscount,
    };
  }

  const pct = Math.max(0, Number(discountPercentage) || 0);
  const totalDiscount = roundCurrency(base * (pct / 100));
  return {
    totalDiscount,
    effectivePercentage: pct,
    displayPercentage: pct,
    displayAmount: totalDiscount,
  };
}

export function formatDiscountLabel({ discountMode, discountPercentage, discountAmount }) {
  if (discountMode === 'amount') {
    return `₹${roundCurrency(discountAmount).toFixed(2)}`;
  }
  return `${roundCurrency(discountPercentage)}%`;
}
